<template src="./registry-organization.html"></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage'
import tabulatorMixin from '@/mixins/tabulator'
import Tabulator from '@/components/tabulator/Tabulator'

export default {
  components: {
    ContextPage,
    Tabulator
  },
  mixins: [tabulatorMixin],
  data () {
    return {
      data: [],
      help: {
        root: Vue.$helpConfig.registryOrganizations
      },
      loader: false,
      loading: false,
      pageLoader: false,
      tabulatorOptions: {
        ajaxURL: Vue.$config.api_root + '/' + Vue.$apiConfig.pagedRegistryOrganizationsGet,
        columns: [
          {
            title: this.$t('registry.organizationId'),
            field: 'id',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center',
            width: 100
          },
          {
            title: this.$t('registry.organizationCompanyNumber'),
            field: 'companyNumber',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center',
            width: 100
          },
          {
            title: this.$t('registry.organizationTaxIdNumber'),
            field: 'taxIdNumber',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center',
            width: 100
          },
          {
            title: this.$t('registry.organizationName'),
            field: 'name',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'left'
          },
          {
            title: this.$t('registry.organizationAddress'),
            field: 'address',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'left'
          },
          {
            title: this.$t('registry.organizationPlace'),
            field: 'place',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'left'
          }
        ],
        rowClick: (e, row) => {
          const registryURL = '/registry/organization/' + row.getData().id
          this.handleRowClickNavigation(e, registryURL)
        }
      }
    }
  }
}
</script>
<style>
.status-active-span {
   background-color: #4caf50;
   color: #fff;
   border-radius: 2px;
   padding: 8px 24px;
   font-size: 12px;
 }

.status-inactive-span {
   background-color: #ECEFF1;
   color: #000;
   border-radius: 2px;
   padding: 8px 24px;
   font-size: 12px;
 }

.status-revoked-span {
   background-color: #ff5252;
   color: #fff;
   border-radius: 2px;
   padding: 8px 24px;
   font-size: 12px;
 }

</style>
